module.exports = __webpack_public_path__ + "img/logo.e8d8223c.svg";